import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportesVentas() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Graficas de Ventas", items: [
      { label: "Venta Mensual", icon: "fas fa-chart-line", color: "#3b82f6", href: "/GraficaVentasMensualComparativa", desc: "Venta mensual comparativa", enabled: !!user.menu_reportes },
      { label: "Venta Mensual Vendedor", icon: "fas fa-chart-bar", color: "#6366f1", href: "/GraficaVentasMensualVendedor", desc: "Venta por vendedor", enabled: !!user.menu_reportes },
      { label: "Venta Estado", icon: "fas fa-globe-americas", color: "#06b6d4", href: "/GraficaVentasEstado", desc: "Venta por estado", enabled: !!user.menu_reportes },
      { label: "Desgloce Ventas", icon: "fas fa-chart-bar", color: "#8b5cf6", href: "/GraficaVentasDesgloce", desc: "Desglose de ventas", enabled: !!user.menu_reportes },
    ]},
    { section: "Inventario y Sell Thru", items: [
      { label: "Valor Inventario", icon: "fas fa-money-check-alt", color: "#10b981", href: "/ValorInventario", desc: "Valor de inventario", enabled: !!user.menu_reportes },
      { label: "Sell Thru", icon: "fas fa-search-dollar", color: "#14b8a6", href: "/SellThru", desc: "Sell thru general", enabled: !!user.menu_reportes },
      { label: "Sell Thru Area", icon: "fas fa-search-dollar", color: "#06b6d4", href: "/SellThruArea", desc: "Sell thru por area", enabled: !!user.menu_reportes },
      { label: "Dashboard Ventas Tabla", icon: "fas fa-list", color: "#64748b", href: "/DashboardVentasTabla", desc: "Tabla de ventas", enabled: !!user.menu_reportes },
    ]},
    { section: "Utilidades", items: [
      { label: "Reporte Utilidades Venta", icon: "fas fa-dollar-sign", color: "#f59e0b", href: "/ReporteUtilidadesVenta", desc: "Utilidades por venta", enabled: !!user.menu_reportes },
      { label: "Reporte Utilidades Articulo", icon: "fas fa-dollar-sign", color: "#ef4444", href: "/ReporteUtilidadesArticulo", desc: "Utilidades por articulo", enabled: !!user.menu_reportes },
      { label: "Reporte Utilidades Cliente", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesCliente", desc: "Utilidades por cliente", enabled: !!user.menu_reportes },
    ]},
  ];
  return (
    <MenuBotones titulo="Reportes de Ventas" descripcion="Reportes y graficas de ventas" icono="fas fa-chart-line" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesReportesVentas;
